var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 420,
    viewBox: "0 0 166 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_4724)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_533_4724)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 420)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 420)",
    fill: "url(#paint0_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 0 419)",
    stroke: "url(#paint1_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 394.583C40.6904 394.583 41.25 394.023 41.25 393.333L41.25 369.684L49.1161 377.55C49.6043 378.038 50.3957 378.038 50.8839 377.55C51.372 377.062 51.372 376.271 50.8839 375.782L40.8839 365.782C40.6495 365.548 40.3315 365.416 40 365.416C39.6685 365.416 39.3505 365.548 39.1161 365.782L29.1161 375.782C28.628 376.271 28.628 377.062 29.1161 377.55C29.6043 378.038 30.3957 378.038 30.8839 377.55L38.75 369.684L38.75 393.333C38.75 394.023 39.3096 394.583 40 394.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 335)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 335)",
    fill: "url(#paint2_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 0 334)",
    stroke: "url(#paint3_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 309.583C40.6904 309.583 41.25 309.023 41.25 308.333L41.25 284.684L49.1161 292.55C49.6043 293.038 50.3957 293.038 50.8839 292.55C51.372 292.062 51.372 291.271 50.8839 290.782L40.8839 280.782C40.6495 280.548 40.3315 280.416 40 280.416C39.6685 280.416 39.3505 280.548 39.1161 280.782L29.1161 290.782C28.628 291.271 28.628 292.062 29.1161 292.55C29.6043 293.038 30.3957 293.038 30.8839 292.55L38.75 284.684L38.75 308.333C38.75 309.023 39.3096 309.583 40 309.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 250)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 250)",
    fill: "url(#paint4_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 0 249)",
    stroke: "url(#paint5_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 224.583C40.6904 224.583 41.25 224.023 41.25 223.333L41.25 199.684L49.1161 207.55C49.6043 208.038 50.3957 208.038 50.8839 207.55C51.372 207.062 51.372 206.271 50.8839 205.782L40.8839 195.782C40.6495 195.548 40.3315 195.416 40 195.416C39.6685 195.416 39.3505 195.548 39.1161 195.782L29.1161 205.782C28.628 206.271 28.628 207.062 29.1161 207.55C29.6043 208.038 30.3957 208.038 30.8839 207.55L38.75 199.684L38.75 223.333C38.75 224.023 39.3096 224.583 40 224.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 165)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 165)",
    fill: "url(#paint6_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 0 164)",
    stroke: "url(#paint7_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 139.583C40.6904 139.583 41.25 139.023 41.25 138.333L41.25 114.684L49.1161 122.55C49.6043 123.038 50.3957 123.038 50.8839 122.55C51.372 122.062 51.372 121.271 50.8839 120.782L40.8839 110.782C40.6495 110.548 40.3315 110.416 40 110.416C39.6685 110.416 39.3505 110.548 39.1161 110.782L29.1161 120.782C28.628 121.271 28.628 122.062 29.1161 122.55C29.6043 123.038 30.3957 123.038 30.8839 122.55L38.75 114.684L38.75 138.333C38.75 139.023 39.3096 139.583 40 139.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 80)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 0 80)",
    fill: "url(#paint8_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 0 79)",
    stroke: "url(#paint9_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 54.583C40.6904 54.583 41.25 54.0234 41.25 53.333L41.25 29.6841L49.1161 37.5502C49.6043 38.0384 50.3957 38.0384 50.8839 37.5502C51.372 37.0621 51.372 36.2706 50.8839 35.7825L40.8839 25.7825C40.6495 25.548 40.3315 25.4163 40 25.4163C39.6685 25.4163 39.3505 25.548 39.1161 25.7825L29.1161 35.7825C28.628 36.2706 28.628 37.0621 29.1161 37.5502C29.6043 38.0384 30.3957 38.0384 30.8839 37.5502L38.75 29.6841L38.75 53.333C38.75 54.0234 39.3096 54.583 40 54.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 420)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 420)",
    fill: "url(#paint10_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 86 419)",
    stroke: "url(#paint11_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 394.583C126.69 394.583 127.25 394.023 127.25 393.333L127.25 369.684L135.116 377.55C135.604 378.038 136.396 378.038 136.884 377.55C137.372 377.062 137.372 376.271 136.884 375.782L126.884 365.782C126.649 365.548 126.332 365.416 126 365.416C125.668 365.416 125.351 365.548 125.116 365.782L115.116 375.782C114.628 376.271 114.628 377.062 115.116 377.55C115.604 378.038 116.396 378.038 116.884 377.55L124.75 369.684L124.75 393.333C124.75 394.023 125.31 394.583 126 394.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 335)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 335)",
    fill: "url(#paint12_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 86 334)",
    stroke: "url(#paint13_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 309.583C126.69 309.583 127.25 309.023 127.25 308.333L127.25 284.684L135.116 292.55C135.604 293.038 136.396 293.038 136.884 292.55C137.372 292.062 137.372 291.271 136.884 290.782L126.884 280.782C126.649 280.548 126.332 280.416 126 280.416C125.668 280.416 125.351 280.548 125.116 280.782L115.116 290.782C114.628 291.271 114.628 292.062 115.116 292.55C115.604 293.038 116.396 293.038 116.884 292.55L124.75 284.684L124.75 308.333C124.75 309.023 125.31 309.583 126 309.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 250)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 250)",
    fill: "url(#paint14_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 86 249)",
    stroke: "url(#paint15_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 224.583C126.69 224.583 127.25 224.023 127.25 223.333L127.25 199.684L135.116 207.55C135.604 208.038 136.396 208.038 136.884 207.55C137.372 207.062 137.372 206.271 136.884 205.782L126.884 195.782C126.649 195.548 126.332 195.416 126 195.416C125.668 195.416 125.351 195.548 125.116 195.782L115.116 205.782C114.628 206.271 114.628 207.062 115.116 207.55C115.604 208.038 116.396 208.038 116.884 207.55L124.75 199.684L124.75 223.333C124.75 224.023 125.31 224.583 126 224.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 165)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 165)",
    fill: "url(#paint16_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 86 164)",
    stroke: "url(#paint17_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 139.583C126.69 139.583 127.25 139.023 127.25 138.333L127.25 114.684L135.116 122.55C135.604 123.038 136.396 123.038 136.884 122.55C137.372 122.062 137.372 121.271 136.884 120.782L126.884 110.782C126.649 110.548 126.332 110.416 126 110.416C125.668 110.416 125.351 110.548 125.116 110.782L115.116 120.782C114.628 121.271 114.628 122.062 115.116 122.55C115.604 123.038 116.396 123.038 116.884 122.55L124.75 114.684L124.75 138.333C124.75 139.023 125.31 139.583 126 139.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 80)",
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    transform: "matrix(1 0 0 -1 86 80)",
    fill: "url(#paint18_linear_533_4724)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    transform: "matrix(1 0 0 -1 86 79)",
    stroke: "url(#paint19_linear_533_4724)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 54.583C126.69 54.583 127.25 54.0234 127.25 53.333L127.25 29.6841L135.116 37.5502C135.604 38.0384 136.396 38.0384 136.884 37.5502C137.372 37.0621 137.372 36.2706 136.884 35.7825L126.884 25.7825C126.649 25.548 126.332 25.4163 126 25.4163C125.668 25.4163 125.351 25.548 125.116 25.7825L115.116 35.7825C114.628 36.2706 114.628 37.0621 115.116 37.5502C115.604 38.0384 116.396 38.0384 116.884 37.5502L124.75 29.6841L124.75 53.333C124.75 54.0234 125.31 54.583 126 54.583Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_533_4724",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_4724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 420,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_533_4724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 420,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 420)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHead);
export default __webpack_public_path__ + "static/media/arrow-head.209ae5a660a905e16d4c0e24b9b60193.svg";
export { ForwardRef as ReactComponent };